import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ProductsBanner from "./ProductsBanner";
import ImageCard from "../../components/ImageCard";
import { fetchTechProducts } from "../../lib/contentful";

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      try {
        const items = await fetchTechProducts({ limit: 50 });
        if (mounted && Array.isArray(items)) {
          setProducts(items);
        }
      } catch (err) {
        setError(err.message || String(err));
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="page pt-20">
      <Navbar />
      <ProductsBanner />
        <div className="px-10 py-12">
           <div className="mt-5">
            <div className="mt-10">
              {loading && (
                <div className="py-10 px-10 pt-0">
                  <div className="flex items-center justify-center h-48">
                    <svg className="w-8 h-8 text-neutral-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                    </svg>
                    <span className="ml-3 text-neutral-500">Loading products...</span>
                  </div>
                </div>
              )}
              {error && <p className="text-sm text-red-400">{error}</p>}
              
              {(!loading && products.length === 0) ? (
                <div className="py-12 text-left col-span-full">
                  <p className="text-neutral-400 font-medium text-lg">Check back soon</p>
                  <p className="text-neutral-500 text-sm mt-2">There are no products right now.</p>
                </div>
              ) : (
                !loading && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {products.map((product, idx) => (
                      <a href={product.link} target="_blank" rel="noopener noreferrer" key={product.slug || product.id || idx} className="block transition-transform duration-300 hover:scale-[1.02]">
                        <ImageCard
                          title={product.title}
                          description={product.description}
                          image={product.image}
                          imageAlt={product.title}
                        />
                      </a>
                    ))}
                  </div>
                )
              )}
            </div>
           </div>
        </div>
      <Footer/>
    </div>
  );
};

export default ProductsPage;
